<script setup>
const { locale } = useI18n();

const query = gql`
  query CustomPages23 {
    cpages(where: {language: ${locale.value
      .toString()
      .toUpperCase()}, pageType: "homepage"}) {
    nodes {
      slug
      title
      homepageconfiguration {

        partners {
          id
          slug
          mediaDetails {
            sizes {
              sourceUrl
              width
            }
          }
        }
      }
    }
  }
}

`;

const props = defineProps({
  // eslint-disable-next-line vue/require-default-prop
  setCursor: Function,
  isProjects: Boolean,
});

const { setCursor } = props;

const variables = { limit: 5 };
const { data } = await useAsyncQuery(query, variables);
</script>

<template>
  <div v-if="data">
    <Partners
      :partners="data.cpages.nodes[0].homepageconfiguration.partners"
      :set-cursor="setCursor"
      :is-projects="isProjects"
    />
  </div>
</template>

<style scoped></style>
